// extracted by mini-css-extract-plugin
export default {"container":"AddTagButton_container__Ki80+"};